// Editable event data. Add new events here across any track/genre.
export const events = [
  {
    id: "workday-wellness-reset",
    title: "Workday Wellness Reset",
    trackId: "lifestyle-wellness",
    category: "Lifestyle & Wellness",
    status: "Waitlist open",
    date: "Date announcing soon",
    duration: "90 minutes",
    mode: "Online / In-person",
    location: "Bengaluru + Online",
    description:
      "A practical reset session for working professionals covering movement, breathwork, food routines, and simple habit planning.",
    ctaLabel: "Join Waitlist",
    image:
      "https://images.pexels.com/photos/5793687/pexels-photo-5793687.jpeg",
  },
  {
    id: "smart-eating",
    title: "Smart Eating for Busy Professionals",
    trackId: "lifestyle-wellness",
    category: "Lifestyle & Wellness",
    status: "Waitlist open",
    date: "Date announcing soon",
    duration: "90 minutes",
    mode: "Online / In-person",
    location: "Online",
    description:
      "Learn practical nutrition planning, office snack strategies, balanced meals, and realistic routines for long workdays.",
    ctaLabel: "Join Waitlist",
    image:
      "https://images.pexels.com/photos/29957507/pexels-photo-29957507.jpeg",
  },
  {
    id: "breathe-unwind",
    title: "Breathe, Unwind & Refocus",
    trackId: "lifestyle-wellness",
    category: "Lifestyle & Wellness",
    status: "Waitlist open",
    date: "Date announcing soon",
    duration: "75 minutes",
    mode: "Online / In-person",
    location: "Online",
    description:
      "A guided relaxation and mindfulness session for mental calm, focus, and workday stress reset.",
    ctaLabel: "Join Waitlist",
    image:
      "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHdvcmtzaG9wJTIwZ2F0aGVyaW5nfGVufDB8fHx8MTc4MzQyNDE0NXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ai-everyday-professionals",
    title: "AI for Everyday Professionals",
    trackId: "technology",
    category: "Technology & AI",
    status: "Notify me",
    date: "Coming soon",
    duration: "2 hours",
    mode: "Online / In-person",
    location: "Bengaluru + Online",
    description:
      "A beginner-friendly event exploring how professionals can understand and use AI tools in everyday work.",
    ctaLabel: "Notify Me",
    image:
      "https://images.pexels.com/photos/28683722/pexels-photo-28683722.jpeg",
  },
  {
    id: "founder-creator-networking",
    title: "Founder & Creator Networking Evening",
    trackId: "community",
    category: "Community",
    status: "Notify me",
    date: "Coming soon",
    duration: "2 hours",
    mode: "In-person",
    location: "Bengaluru",
    description:
      "A curated networking experience for founders, creators, freelancers, and professionals looking to connect meaningfully.",
    ctaLabel: "Notify Me",
    image:
      "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBuZXR3b3JraW5nJTIwZXZlbnR8ZW58MHx8fHwxNzgzNDI0MTQ1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "corporate-wellness-starter",
    title: "Corporate Wellness Starter Session",
    trackId: "lifestyle-wellness",
    category: "Corporate",
    status: "By request",
    date: "By request",
    duration: "60–90 minutes",
    mode: "Online / On-site",
    location: "Anywhere",
    description:
      "A customized introductory session for companies looking to support employee wellbeing and engagement.",
    ctaLabel: "Request Proposal",
    image:
      "https://images.unsplash.com/photo-1561489413-985b06da5bee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBuZXR3b3JraW5nJTIwZXZlbnR8ZW58MHx8fHwxNzgzNDI0MTQ1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const eventFilterOptions = [
  { label: "All", value: "all" },
  { label: "Lifestyle & Wellness", value: "Lifestyle & Wellness" },
  { label: "Technology", value: "Technology & AI" },
  { label: "Business", value: "Business & Leadership" },
  { label: "Creativity", value: "Creativity & Culture" },
  { label: "Community", value: "Community" },
  { label: "Corporate", value: "Corporate" },
];
